import React from 'react';
import { client } from '../components/services/api/pocketbase';



function Testapi() {

    // useEffect(() => {
    //     const fetchData = async () => {
    //       try {
    //         const records = await client.collection('posts').getFullList({
    //           sort: '-created',
    //         });
    //         console.log(records);
    //       } catch (error) {
    //         console.error('Error fetching data:', error);
    //       }
    //     };
    
    //     fetchData();
    //   }, []);


    async function auth() {
        try {
            await client.collection('users').requestVerification('rajat.shinde201@pccoepune.org');

        } catch (error) {
            console.log(error);

        }
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        console.log(event);
        const formData = new FormData(event.target);
        formData.get('email');
        formData.get('password');
        auth();
        console.log(`Form submitted with name: ${formData.get('fname')}`);
      };

  return (
      <div>
          <form onSubmit={handleSubmit} >
              <input type="text" id="email" name="email" placeholder="Your name.."/>
              <input type="text" id="password" name="password" placeholder="Your name.."/>
                  <input type="submit" value="Submit"/>
                  </form>

      </div>
  )
}

export default Testapi;
